import React from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import GuestRoute from "@/components/auth/GuestRoute";
import UiPackShell from "@/components/simple/UiPackShell";
import UiPackLogin from "@/components/simple/UiPackLogin";
import UiPackHome from "@/components/simple/UiPackHome";
import UiPackPos from "@/components/simple/UiPackPos";
import UiPackTables from "@/components/simple/UiPackTables";
import UiPackKitchen from "@/components/simple/UiPackKitchen";
import UiPackWaiter from "@/components/simple/UiPackWaiter";
import UiPackMastersHub from "@/components/simple/UiPackMastersHub";
import UiPackProductsList from "@/components/simple/UiPackProductsList";
import SimpleMasterChrome from "@/components/simple/SimpleMasterChrome";
import UiPackReportLayout from "@/components/simple/UiPackReportLayout";
import UiPackAdminHub from "@/components/simple/UiPackAdminHub";
import UiPackOperationsHub from "@/components/simple/UiPackOperationsHub";
import SimpleAdminChrome from "@/components/simple/SimpleAdminChrome";

import QrMenu from "@/pages/QrMenu";
import ConsoleProtectedRoute from "@/components/console/ConsoleProtectedRoute";
import ConsoleShell from "@/components/console/ConsoleShell";
import ConsoleLogin from "@/pages/console/ConsoleLogin";
import ConsoleDashboard from "@/pages/console/ConsoleDashboard";
import ConsoleCompanies from "@/pages/console/ConsoleCompanies";
import ConsoleCompanyDetail from "@/pages/console/ConsoleCompanyDetail";
import ConsoleAccessEntry, { ConsoleAccessClosed } from "@/pages/ConsoleAccessEntry";
import HoldBills from "@/pages/HoldBills";
import PosBillHistory from "@/pages/PosBillHistory";
import DeliveryManagement from "@/pages/DeliveryManagement";
import TableDesigner from "@/pages/TableDesigner";
import MenuItemFormPage from "@/pages/masters/MenuItemFormPage";
import MainMenuMaster from "@/pages/masters/MainMenuMaster";
import SubMenuMaster from "@/pages/masters/SubMenuMaster";
import KitchenNotesMaster from "@/pages/masters/KitchenNotesMaster";
import KotMaster from "@/pages/masters/KotMaster";
// import PromotionsMaster from "@/pages/masters/PromotionsMaster";
import TablesMaster from "@/pages/masters/TablesMaster";
import CustomerMaster from "@/pages/masters/CustomerMaster";
import SupplierMaster from "@/pages/masters/SupplierMaster";
import DeliveryPersonMaster from "@/pages/masters/DeliveryPersonMaster";
import DeliveryAreaMaster from "@/pages/masters/DeliveryAreaMaster";
// Accounts menu pages hidden — keep report pages imported (used under /reports)
// import ScheduleMaster from "@/pages/accounts/ScheduleMaster";
// import AccountMaster from "@/pages/accounts/AccountMaster";
// import ReceiptVoucher from "@/pages/accounts/ReceiptVoucher";
// import PaymentVoucher from "@/pages/accounts/PaymentVoucher";
// import JournalVoucher from "@/pages/accounts/JournalVoucher";
// import ContraVoucher from "@/pages/accounts/ContraVoucher";
// import DebitNoteVoucher from "@/pages/accounts/DebitNoteVoucher";
// import CreditNoteVoucher from "@/pages/accounts/CreditNoteVoucher";
import LedgerReport from "@/pages/accounts/LedgerReport";
import TrialBalanceReport from "@/pages/accounts/TrialBalanceReport";
import ProfitLossReport from "@/pages/accounts/ProfitLossReport";
import BalanceSheetReport from "@/pages/accounts/BalanceSheetReport";
import AccountBooks from "@/pages/accounts/AccountBooks";
// Disabled routes:
// <Route path="/accounts/schedules" element={<ScheduleMaster />} />
// <Route path="/accounts/accounts" element={<AccountMaster />} />
// <Route path="/accounts/receipt" element={<ReceiptVoucher />} />
// <Route path="/accounts/payment" element={<PaymentVoucher />} />
// <Route path="/accounts/journal" element={<JournalVoucher />} />
// <Route path="/accounts/contra" element={<ContraVoucher />} />
// <Route path="/accounts/debit-note" element={<DebitNoteVoucher />} />
// <Route path="/accounts/credit-note" element={<CreditNoteVoucher />} />
// <Route path="/accounts/ledger" element={<LedgerReport />} />
// <Route path="/accounts/trial-balance" element={<TrialBalanceReport />} />
// <Route path="/accounts/profit-loss" element={<ProfitLossReport />} />
// <Route path="/accounts/balance-sheet" element={<BalanceSheetReport />} />
// <Route path="/accounts/cash-book" element={<AccountBooks />} />
// <Route path="/accounts/bank-book" element={<AccountBooks />} />
// <Route path="/accounts/day-book" element={<AccountBooks />} />
import ReportCenterHome from "@/pages/reports/ReportCenterHome";
import SalesReports from "@/pages/reports/SalesReports";
import CashReports from "@/pages/reports/CashReports";
import OperationsReports from "@/pages/reports/OperationsReports";
import StockReports from "@/pages/reports/StockReports";
import FinancialReports from "@/pages/reports/FinancialReports";
import BacklogReports from "@/pages/reports/BacklogReports";
import DeliveryReports from "@/pages/reports/DeliveryReports";
import UsersPage from "@/pages/admin/Users";
import RolesPage from "@/pages/admin/Roles";
import AuditLogPage from "@/pages/admin/AuditLog";
import CountersPage from "@/pages/admin/Counters";
import AggregatorHubPage from "@/pages/admin/AggregatorHub";
import WhatsAppSettingsPage from "@/pages/admin/WhatsAppSettings";
import PrintersPage from "@/pages/admin/Printers";
import CompanySetup from "@/pages/admin/CompanySetup";
import RestaurantSetup from "@/pages/admin/RestaurantSetup";
import TaxSettings from "@/pages/admin/TaxSettings";
import GeneralSettings from "@/pages/admin/GeneralSettings";
// import InventoryHubPage from "@/pages/inventory/InventoryHub";
// Disabled masters routes:
// <Route path="/masters/promotions" element={<PromotionsMaster />} />
// <Route path="/inventory" element={<InventoryHubPage />} />
import LoyaltySettingsPage from "@/pages/admin/LoyaltySettings";
import TipSettingsPage from "@/pages/admin/TipSettings";
import TipPoolReport from "@/pages/reports/TipPoolReport";
import ReservationsHub from "@/pages/operations/ReservationsHub";
import BranchComparisonReport from "@/pages/reports/BranchComparisonReport";
import SupplierComplianceReport from "@/pages/reports/SupplierComplianceReport";
import StoreHome from "@/pages/store/StoreHome";
import StoreCatalog from "@/pages/store/StoreCatalog";
import StoreCheckout from "@/pages/store/StoreCheckout";
import OnlineOrders from "@/pages/online/OnlineOrders";
import OnlineOrderHistory from "@/pages/online/OnlineOrderHistory";
import OnlineStoreSettings from "@/pages/admin/OnlineStoreSettings";

const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, "") || undefined;

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={routerBasename}>
        <Routes>
          <Route
            path="/login"
            element={
              <GuestRoute>
                <UiPackLogin />
              </GuestRoute>
            }
          />
          <Route path="/menu/:branchCode" element={<QrMenu />} />
          <Route path="/menu/:branchCode/table/:tableCode" element={<QrMenu />} />
          <Route path="/s/:branchCode" element={<StoreHome />} />
          <Route path="/s/:branchCode/catalog" element={<StoreCatalog />} />
          <Route path="/s/:branchCode/checkout" element={<StoreCheckout />} />

          <Route path="/console-access" element={<ConsoleAccessEntry />} />
          <Route path="/console-access/closed" element={<ConsoleAccessClosed />} />
          <Route path="/console/login" element={<ConsoleLogin />} />
          <Route
            path="/console"
            element={
              <ConsoleProtectedRoute>
                <ConsoleShell />
              </ConsoleProtectedRoute>
            }
          >
            <Route index element={<ConsoleDashboard />} />
            <Route path="companies" element={<ConsoleCompanies />} />
            <Route path="companies/:id" element={<ConsoleCompanyDetail />} />
          </Route>

          <Route
            element={
              <ProtectedRoute>
                <UiPackShell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<UiPackHome />} />
            <Route path="/operations" element={<UiPackOperationsHub />} />
            <Route path="/pos" element={<UiPackPos />} />
            <Route path="/waiter" element={<UiPackWaiter />} />
            <Route path="/pos/held-bills" element={<HoldBills />} />
            <Route path="/pos/bill-history" element={<Navigate to="/reports/bill-history" replace />} />
            <Route path="/tables" element={<UiPackTables />} />
            <Route path="/reservations" element={<ReservationsHub />} />
            <Route path="/kds" element={<UiPackKitchen />} />
            <Route path="/delivery" element={<DeliveryManagement />} />
            <Route path="/online/orders" element={<OnlineOrders />} />
            <Route path="/online/history" element={<OnlineOrderHistory />} />

            <Route path="/masters" element={<UiPackMastersHub />} />
            <Route path="/masters/main-menu" element={<SimpleMasterChrome><MainMenuMaster /></SimpleMasterChrome>} />
            <Route path="/masters/sub-menu" element={<SimpleMasterChrome><SubMenuMaster /></SimpleMasterChrome>} />
            <Route path="/masters/menu-item" element={<Navigate to="/masters/menu-item/list" replace />} />
            <Route path="/masters/menu-item/list" element={<UiPackProductsList />} />
            <Route path="/masters/menu-item/new" element={<SimpleMasterChrome><MenuItemFormPage /></SimpleMasterChrome>} />
            <Route path="/masters/menu-item/:id/edit" element={<SimpleMasterChrome><MenuItemFormPage /></SimpleMasterChrome>} />
            <Route path="/masters/kitchen-notes" element={<SimpleMasterChrome><KitchenNotesMaster /></SimpleMasterChrome>} />
            <Route path="/masters/kot" element={<SimpleMasterChrome><KotMaster /></SimpleMasterChrome>} />
            {/* Promotions + Inventory & Recipes hidden from Masters */}
            <Route path="/masters/tables" element={<SimpleMasterChrome><TablesMaster /></SimpleMasterChrome>} />
            <Route path="/masters/table-designer" element={<SimpleMasterChrome><TableDesigner /></SimpleMasterChrome>} />
            <Route path="/masters/customers" element={<SimpleMasterChrome><CustomerMaster /></SimpleMasterChrome>} />
            <Route path="/masters/suppliers" element={<SimpleMasterChrome><SupplierMaster /></SimpleMasterChrome>} />
            <Route path="/masters/delivery-areas" element={<SimpleMasterChrome><DeliveryAreaMaster /></SimpleMasterChrome>} />
            <Route path="/masters/delivery-persons" element={<SimpleMasterChrome><DeliveryPersonMaster /></SimpleMasterChrome>} />

            {/* Accounts module hidden from top nav — /accounts/* routes disabled (see commented imports above) */}

            <Route path="/reports" element={<UiPackReportLayout />}>
              <Route index element={<ReportCenterHome />} />
              <Route path="bill-history" element={<PosBillHistory />} />
              <Route path="daily-sales" element={<SalesReports />} />
              <Route path="counter-sales" element={<SalesReports />} />
              <Route path="item-sales" element={<SalesReports />} />
              <Route path="tax" element={<SalesReports />} />
              <Route path="cash-collection" element={<CashReports />} />
              <Route path="z-report" element={<CashReports />} />
              <Route path="x-report" element={<CashReports />} />
              <Route path="sales-day-book" element={<CashReports />} />
              <Route path="customer-sales" element={<OperationsReports />} />
              <Route path="delivery-summary" element={<DeliveryReports />} />
              <Route path="delivery-detail" element={<DeliveryReports />} />
              <Route path="delivery-person-sales" element={<DeliveryReports />} />
              <Route path="delivery-area-sales" element={<OperationsReports />} />
              <Route path="condensed-stock" element={<StockReports />} />
              <Route path="opening-stock" element={<StockReports />} />
              <Route path="physical-stock" element={<StockReports />} />
              <Route path="financial-statements" element={<FinancialReports />} />
              <Route path="customer-age-wise" element={<FinancialReports />} />
              <Route path="supplier-age-wise" element={<FinancialReports />} />
              <Route path="customer-ledger" element={<FinancialReports />} />
              <Route path="supplier-ledger" element={<FinancialReports />} />
              <Route path="category-sales" element={<BacklogReports />} />
              <Route path="top-items" element={<BacklogReports />} />
              <Route path="supplier-summary" element={<BacklogReports />} />
              <Route path="kitchen" element={<BacklogReports />} />
              <Route path="order-summary" element={<BacklogReports />} />
              <Route path="tip-pool" element={<TipPoolReport />} />
              <Route path="branch-comparison" element={<BranchComparisonReport />} />
              <Route path="supplier-compliance" element={<SupplierComplianceReport />} />
              <Route path="ledger" element={<LedgerReport />} />
              <Route path="trial-balance" element={<TrialBalanceReport />} />
              <Route path="profit-loss" element={<ProfitLossReport />} />
              <Route path="balance-sheet" element={<BalanceSheetReport />} />
              <Route path="cash-book" element={<AccountBooks />} />
              <Route path="bank-book" element={<AccountBooks />} />
              <Route path="day-book" element={<AccountBooks />} />
            </Route>

            <Route path="/admin" element={<UiPackAdminHub />} />
            <Route path="/admin/users" element={<SimpleAdminChrome><UsersPage /></SimpleAdminChrome>} />
            <Route path="/admin/roles" element={<SimpleAdminChrome><RolesPage /></SimpleAdminChrome>} />
            <Route path="/admin/audit-log" element={<SimpleAdminChrome><AuditLogPage /></SimpleAdminChrome>} />
            <Route path="/admin/counters" element={<SimpleAdminChrome><CountersPage /></SimpleAdminChrome>} />
            <Route path="/admin/aggregators" element={<SimpleAdminChrome><AggregatorHubPage /></SimpleAdminChrome>} />
            <Route path="/admin/whatsapp" element={<SimpleAdminChrome><WhatsAppSettingsPage /></SimpleAdminChrome>} />
            <Route path="/admin/loyalty" element={<SimpleAdminChrome><LoyaltySettingsPage /></SimpleAdminChrome>} />
            <Route path="/admin/tips" element={<SimpleAdminChrome><TipSettingsPage /></SimpleAdminChrome>} />
            <Route path="/admin/printers" element={<SimpleAdminChrome><PrintersPage /></SimpleAdminChrome>} />
            <Route path="/admin/company" element={<SimpleAdminChrome><CompanySetup /></SimpleAdminChrome>} />
            <Route path="/admin/restaurant" element={<SimpleAdminChrome><RestaurantSetup /></SimpleAdminChrome>} />
            <Route path="/admin/tax" element={<SimpleAdminChrome><TaxSettings /></SimpleAdminChrome>} />
            <Route path="/admin/general" element={<SimpleAdminChrome><GeneralSettings /></SimpleAdminChrome>} />
            <Route path="/admin/online-store" element={<SimpleAdminChrome><OnlineStoreSettings /></SimpleAdminChrome>} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

export default App;
